export default "__VITE_ASSET__0kNgMEPc__"